import DecimalInput from 'components/forms/inputs/rhf-inputs/DecimalInput.tsx';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import PaymentCurrencyNotice from 'pages/invoices/layout/views/components/PaymentCurrencyNotice';
import { FormProvider, useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';
import { paymentCurrencyInputClassName } from 'utils/usePaymentCurrencyMode';
import { ModalFooter } from '../ModalFooter';
import { ModalHeader } from '../ModalHeader';

interface Props {
    onChange: (value: number | null) => Promise<void> | void;
    onClose: () => void;
    isPaymentCurrencyMode?: boolean;
    currency?: string;
    /** How many timecards the rate applies to, which the new design's header says. */
    count?: number;
}

type PriceForm = {
    hourlyPrice: number | null;
};

const TimecardBulkPriceChangeModal = (props: Props) => {
    const { onClose, onChange, isPaymentCurrencyMode, currency, count } = props;
    const isNew = useIsNewDesign();

    const methods = useForm<PriceForm>({
        defaultValues: { hourlyPrice: null },
        values: { hourlyPrice: null },
    });

    const { handleSubmit, control } = methods;

    const onSave = () => {
        handleSubmit(async (data) => {
            await onChange(data.hourlyPrice);
            onClose();
        })();
    };

    return (
        <>
            <ModalHeader
                kit
                title={t('invoices.actions.apply-new-hourly-rate')}
                description={
                    count === undefined ? undefined : (
                        <FormattedMessage id="invoices.bulk.for-selected-timecards" values={{ count }} />
                    )
                }
                onCancel={onClose}
            />
            <div className="new:px-6 new:py-6 h-full overflow-y-auto px-8 py-[38px] max-sm:px-4 max-sm:py-6">
                {isPaymentCurrencyMode && currency && <PaymentCurrencyNotice currency={currency} className="mb-4" />}
                <FormProvider {...methods}>
                    <div className="flex flex-row gap-4">
                        <DecimalInput
                            control={control}
                            name="hourlyPrice"
                            label="invoices.details.table.hourly-rate"
                            required
                            suffixComponent={isNew && currency ? `${currency}/h` : undefined}
                            wrapperClassName={cn('w-1/2', isPaymentCurrencyMode && paymentCurrencyInputClassName)}
                        />
                    </div>
                </FormProvider>
            </div>
            <ModalFooter kit onCancel={onClose} onSave={onSave} />
        </>
    );
};

export default TimecardBulkPriceChangeModal;
